import { listKeyitem } from '../../../../shared/Models/SelectItems';
import { FormsFieldService } from '../../services/forms-fields.service';
import { FormFields } from '../../models/form.field';

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbToastrService, NbComponentStatus, NbDialogRef } from '@nebular/theme';
import { SelectItems } from '../../../../shared/Models/SelectItems';

@Component({
  selector: 'app-update-fields',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss'],
})
export class UpdateFieldComponent implements OnInit {
  requiredCreateDate: listKeyitem[] = [];
  formFields: FormFields = {} as FormFields;
  users: any[];
  legals: any[];
  userSectionFlg: boolean;
  legalSectionFlg: boolean;
  userEscalationSectionFlg: boolean;
  escalDays: number;
  escaleHours: number;
  formMasterId: number;
  finishLoading: boolean;
  sectionId: number;
  formFieldId: number;
  constructor(
    private service: FormsFieldService,
    private route: ActivatedRoute,
    private toastrService: NbToastrService,
    private router: Router,
    private diag: NbDialogRef<UpdateFieldComponent>
  ) {}
  timeType = [
    { name: 'شهر', id: 1 },
    { name: 'يوم', id: 2 },
    { name: 'ساعه', id: 3 },
  ];
  assignUserTypes = [
    { name: 'Personality', id: 1 },
    { name: 'Legal', id: 2 },
    { name: 'User Group', id: 3 },
    { name: 'RoleGroup', id: 5 },
  ];
  escalationMethods = [
    { name: 'One Level Up', id: 1 },
    { name: 'Multi Level Up', id: 2 },
    { name: 'Personal', id: 3 },
  ];
  ngOnInit() {
    this.service.getUpdate(this.formFieldId).subscribe((res) => {
      this.formFields = res.entity;
      this.requiredCreateDate = res.selectListItems;
      this.finishLoading = true;
    });
  }
  loadRequiredCreateDate() {
    this.service.getCreateNew().subscribe((res) => {
      this.requiredCreateDate = res;
      this.finishLoading = true;
    });
  }

  addNewPhase() {
    this.service.post(this.formFields).subscribe((res) => {});
  }
 
  escalationChange($event) {
    switch ($event) {
      case 3:
        if (this.users == null || this.users.length === 0) {
          this.service.getPhaseUsers(1).subscribe((res) => {
            this.users = res;
          });
        }
        this.userEscalationSectionFlg = true;
        break;
      default:
        this.userEscalationSectionFlg = false;
    }
  }

  initalize() {
    this.userSectionFlg = false;
    this.legalSectionFlg = false;
  }
  save() {
    this.service.put(this.formFieldId, this.formFields).subscribe((res) => {
      const position = 'bottom-right';
      this.toastrService.success(`update field ${this.formFields.name} successfully`, 'success', { duration: 4000 });
      this.diag.close('true');
    });
  }
  showToast(position, message, status: NbComponentStatus) {
    this.toastrService.show(message, '', { position, status });
  }
  back() {
    const route = ['workflow'];
    this.router.navigate(route);
  }
}
